import qs from 'qs';
import { Lens } from './lens';
export const parseQueryStringLens = new Lens(search => qs.parse(search, {
  ignoreQueryPrefix: true
}), x => qs.stringify(x, {
  addQueryPrefix: true
}));